import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M14.667 1.7H1.333a.667.667 0 0 0-.666.667V5.7A2 2 0 0 0 2 7.58v6.12a.667.667 0 0 0 .667.667h10.666A.667.667 0 0 0 14 13.7V7.58a2 2 0 0 0 1.333-1.88V2.367a.667.667 0 0 0-.666-.667M10 3.033h1.333V5.7A.667.667 0 1 1 10 5.7zm-2.667 0h1.334V5.7a.667.667 0 0 1-1.334 0zm-2.666 0H6V5.7a.667.667 0 0 1-1.333 0zm-2 3.334A.667.667 0 0 1 2 5.7V3.033h1.333V5.7a.667.667 0 0 1-.666.667m6.666 6.666H6.667V11.7a1.333 1.333 0 1 1 2.666 0zm3.334 0h-2V11.7a2.667 2.667 0 1 0-5.334 0v1.333h-2V7.58c.245-.091.472-.227.667-.4a2 2 0 0 0 2.667 0 2 2 0 0 0 2.666 0 2 2 0 0 0 2.667 0c.196.173.422.309.667.4zM14 5.7a.667.667 0 0 1-1.333 0V3.033H14z"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })